/**
 * Format a number as a USD dollar amount with thousand separators.
 * Always uses absolute value — caller handles the sign (+/-/$).
 *
 * Examples:
 *   fmtUSD(1234.56)    → "1,234.56"
 *   fmtUSD(-1234.56)   → "1,234.56"  (abs)
 *   fmtUSD(50)          → "50.00"
 *   fmtUSD(0)           → "0.00"
 */
export const fmtUSD = (n) =>
  Math.abs(Number(n) || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/**
 * Safely extract a numeric P&L value from a trade object.
 * Handles strings, NaN, undefined, null, and objects gracefully.
 *
 * SINGLE SOURCE OF TRUTH for reading trade.pnl across the entire app.
 * Every component/hook should use this instead of raw `trade.pnl`.
 *
 * Examples:
 *   safePnl({ pnl: 125.50 })       → 125.50
 *   safePnl({ pnl: "-50.25" })     → -50.25
 *   safePnl({ pnl: undefined })    → 0
 *   safePnl({ pnl: NaN })          → 0
 *   safePnl({ pnl: {obj: true} })  → 0
 *   safePnl(null)                   → 0
 */
export const safePnl = (trade) => {
  const val = trade?.pnl;
  if (val == null || typeof val === 'object') return 0;
  const num = Number(val);
  return isNaN(num) ? 0 : num;
};
